<template lang="pug">
  div
    header.site-header(v-bind:class="{'site-header--static': isStaticHeader}")
      .row.h-100.align-items-center
        .col-auto.d-flex.d-xl-none
          .site-header__toggle#toggle-button(data-slideout-ignore)
            font-awesome-icon(:icon="['far', 'bars']")
        .col-auto
          a(href="/", title='Spark Intertrade')
            img.site-header__logo(src="/img/frontend/logo/logo.svg", alt='')
        .col
          .row.align-items-center
            .col-11.col-xl
              search-input
            .col-xl-auto.d-none.d-xl-flex
              .site-header__cta
                .site-header__cta-item
                  font-awesome-icon.site-header__cta-icon.site-header__cta-icon--line(
                    :icon="['fab', 'line']"
                  )
                  a.site-header__cta-link(href='https://line.me/ti/p/~@spabattery' target="_blank" @click="onLineClicked") @spabattery
                .site-header__cta-item
                  font-awesome-icon.fa-flip-horizontal.site-header__cta-icon.site-header__cta-icon--call(:icon="['fas', 'phone']")
                  a.site-header__cta-link(href='tel:02-434-0253' target="_blank" @click="onCallClicked") 02-434-0253
            .col-xl-auto.d-none.d-xl-flex
              router-link.text-black(:to="{ name: 'account.payment-notify' }") {{ trans('menus.frontend.navigation.payment-notify-short') }}
            .col-xl-auto.d-none.d-xl-flex(v-if="!$store.getters['auth/user'].locale || $store.getters['auth/user'].locale == 'th'")
              img.site-header__language-switcher(src="/img/frontend/icons/flags/uk.png" alt="English Version" @click.prevent="setLocale('en')")
            .col-xl-auto.d-none.d-xl-flex(v-if="$store.getters['auth/user'].locale && $store.getters['auth/user'].locale == 'en'")
              img.site-header__language-switcher(src="/img/frontend/icons/flags/thailand.png" alt="Thai Version" @click.prevent="setLocale('th')")
          .row.d-none.d-xl-flex
            .col-xl-12
              ul.site-header__navigation.list-unstyled.list-inline
                li.site-header__navigation-item.list-inline-item(v-for="(item, key) in menu_items[0]" :key="item.id")
                  a.site-header__navigation-link(
                    :href='item.url' :title='item.name'
                    v-if="!menu_items[item.id]"
                  ) {{ item.name }}
                  span.d-inline-block.site-header__navigation-link(
                    to='#' :title='item.name'
                    :id="'menu-dropdown-' + item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static"
                    v-if="menu_items[item.id]"
                  ) {{ item.name }}
                    font-awesome-icon.dropdown-menu__toggle(:icon=['far', 'angle-down'])
                    ul.dropdown-menu(v-if="menu_items[item.id]" :aria-labelledby="'menu-dropdown-' + item.id")
                      li(v-for="(levelOne, index) in menu_items[item.id]" v-if="index < 15" )
                        router-link.site-header__navigation-link(
                          :to='levelOne.url' :title='levelOne.name' v-if=""
                        )
                          .row.no-gutters.align-items-center
                            .col-auto
                              router-link.site-header__navigation-link(
                                :to='levelOne.url' :title='levelOne.name' v-if=""
                              ) {{ levelOne.name }}
                            .col.text-right.pt-1
                              font-awesome-icon.dropdown-menu__toggle(:icon=['far', 'angle-down'] v-if="menu_items[levelOne.id]")
                          ul.dropdown-menu__sub(v-if="menu_items[levelOne.id]")
                            li.dropdown-menu__sub-header
                              .dropdown-menu__sub-header-title {{ levelOne.name }}
                              img.dropdown-menu__sub-header-image(v-if="levelOne.image" :src="levelOne.image")
                            li(v-for="levelTwo in menu_items[levelOne.id]")
                              router-link.site-header__navigation-link(:to='levelTwo.url' :title='levelTwo.name') {{ levelTwo.name }}

                      hr.mb-2(v-if="menu_items[item.id].length >= 15")
                      li
                        router-link.site-header__navigation-link.text-primary(
                          to='/shop' title='All Categories' v-if="menu_items[item.id].length >= 15"
                        ) All Categories
        .col-auto.h-100.align-self-start
          .site-header__quick-navigation
            .site-header__quick-navigation-item.site-header__quick-navigation-item--user.d-none.d-lg-flex
              .site-header__quick-navigation-item-content
                router-link.site-header__quick-navigation-item-link(:to="{ name: 'login' }" v-if="!$store.getters['auth/isLoggedIn']")
                  font-awesome-icon.site-header__quick-navigation-item-icon(:icon="['far', 'user-circle']")
                  span.site-header__quick-navigation-item-title Login/Signup
                .site-header__quick-navigation-item-link(v-if="$store.getters['auth/isLoggedIn']")
                  font-awesome-icon.site-header__quick-navigation-item-icon.site-header__quick-navigation-item-icon--primary(:icon="['far', 'user-circle']")
                  span.site-header__quick-navigation-item-title {{ $store.getters['auth/user'].first_name }}
                  .site-header__dropdown
                    ul.fa-ul
                      li
                        router-link(:to={ name: 'account.orders' } :title="trans('menus.frontend.navigation.orders')")
                          span.fa-li
                            font-awesome-icon(:icon="['far', 'list-alt']")
                          | {{ trans('menus.frontend.navigation.orders') }}
                      li
                        router-link(:to="{ name: 'account.payment-notify' }" :title="trans('menus.frontend.navigation.payment-notify-short')")
                          span.fa-li
                            font-awesome-icon(:icon="['far', 'comment-alt-dollar']")
                          | {{ trans('menus.frontend.navigation.payment-notify-short') }}
                      li
                        router-link(:to={ name: 'account.profile' } :title="trans('menus.frontend.navigation.account')")
                          span.fa-li
                            font-awesome-icon(:icon="['far', 'user']")
                          | {{ trans('menus.frontend.navigation.account') }}
                      li
                        router-link(:to="{ name: 'account.wishlist' }", :title="trans('menus.frontend.navigation.wishlist')")
                          span.fa-li
                            font-awesome-icon(:icon="['far', 'heart']")
                          | {{ trans('menus.frontend.navigation.wishlist') }}
                      li
                        router-link(:to="{ name: 'account.change-password' }", :title="trans('menus.frontend.navigation.change-password')")
                          span.fa-li
                            font-awesome-icon(:icon="['far', 'lock-alt']")
                          | {{ trans('menus.frontend.navigation.change-password') }}
                      li
                        a(href="#" @click="logout" :title="trans('navs.general.logout')")
                          span.fa-li
                            font-awesome-icon(:icon="['far', 'sign-out']")
                          | {{ trans('navs.general.logout') }}
                    hr
                    strong.text-left.d-block {{ trans('labels.frontend.footer.help') }}
                    ul.fa-ul.site-header__dropdown-help-list
                      li
                        router-link(:to="{ name: 'help.single', params: { slug: 'how-to-order' } }")
                          | {{ trans('menus.frontend.navigation.how-to-buy') }}
                      li
                        router-link(:to="{ name: 'help.single', params: { slug: 'tracking' } }")
                          | {{ trans('menus.frontend.navigation.check-tracking') }}
                      li
                        router-link(:to="{ name: 'help.single', params: { slug: 'faqs' } }")
                          | {{ trans('menus.frontend.navigation.faqs') }}
                      li
                        router-link(:to="{ name: 'help.single', params: { slug: 'shipping' } }")
                          | {{ trans('menus.frontend.navigation.how-to-ship') }}
                      li
                        router-link(:to="{ name: 'help.single', params: { slug: 'how-to-claim' } }")
                          | {{ trans('menus.frontend.navigation.how-to-claim') }}
                      li
                        a(@click.prevent="logout") {{ trans('navs.general.logout') }}
            .site-header__quick-navigation-item.site-header__quick-navigation-item--primary
              .site-header__quick-navigation-item-content
                .site-header__quick-navigation-item-link.d-xl-block.d-none
                  font-awesome-icon.site-header__quick-navigation-item-icon(:icon="['far', 'shopping-cart']")
                  span.site-header__quick-navigation-item-title {{ $store.getters['cart/total_items'] | numeral }}
                  .site-header__dropdown.site-header__dropdown--cart(v-if="$store.getters['cart/total_items'] > 0")
                    cart-dropdown
                router-link.site-header__quick-navigation-item-link.d-xl-none.d-lg-block(:to="{ name: 'cart' }")
                  font-awesome-icon.site-header__quick-navigation-item-icon(:icon="['far', 'shopping-cart']")
                  span.site-header__quick-navigation-item-title {{ $store.getters['cart/total_items'] | numeral }}
</template>

<script>
import CartDropdown from '../cart/CartDropdown.vue';
import SearchInput from '../search/SearchInput.vue';
import notify from '../notify';
import { RepositoryFactory } from '../../repositoryFactory';
import ConversionManager from '../../mixins/ConversionManager';

const MenuRepository = RepositoryFactory.get('menu');

export default {
  computed: {
    isStaticHeader() {
      const { name } = this.$route;
      return name === 'shop.category' || name === 'search.results' || name === 'shop.category.subcategory';
    }
  },
  components: {
    CartDropdown,
    SearchInput,
  },
  mixins: [ConversionManager],
  data() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'auth/set_locale') {
        console.log('setting locale', mutation.payload);
        // eslint-disable-next-line no-restricted-globals
        location.reload();
        console.log('current locale is ', Lang.locale);
      }
    });

    return {
      menu_items: [],
    };
  },
  created() {
    this.getMenu();
  },
  methods: {
    async getMenu() {
      const { data } = await MenuRepository.get('header-menu', { lang: this.$store.getters['auth/user'].locale || 'th' }).then((resp) => resp.data);
      this.menu_items = data.items;
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      notify.success(this, { title: Lang.get('alerts.frontend.general.logged_out'), text: '' });
    },
    onLineClicked() {
      this.trackEvent('Click', 'Buttons', 'Add Line', 'Add Line (Header)', 1);
    },
    onCallClicked() {
      this.trackEvent('Click', 'Buttons', 'Call', 'Call (Header)', 1);
    },
    setLocale(lang) {
      this.$store.dispatch('auth/setLocale', lang);
    },
  },
};
</script>
